import {
  NOTE_BODY_FONT_SIZE,
  NOTE_BODY_LINE_HEIGHT,
  NOTE_BODY_MAX_TEXT_WIDTH,
  NOTE_BODY_PAD_X,
  NOTE_BODY_PAD_Y,
  NOTE_BODY_RADIUS,
  NOTE_BYLINE_FONT_SIZE,
  NOTE_CARD_FRAME_INSET,
  NOTE_CARD_HEADER_PAD_X,
  NOTE_CARD_HEADER_PAD_Y,
  NOTE_CARD_RADIUS,
  NOTE_CROP_CARD_GAP,
  NOTE_CROP_SIDE,
  NOTE_ENTRY_GAP,
  NOTE_GROUP_FONT_SIZE,
  NOTE_HEADER_HEIGHT,
  NOTE_HEADER_LINE_GAP,
  NOTE_PAGE_MARGIN,
} from "../appendNotePages/constants";
import type { ComputeNoteMetrics } from "./types";

export const computeNoteMetrics: ComputeNoteMetrics = ({
  scale,
  pdfPageWidth,
  pdfPageHeight,
  titleTop,
}) => {
  const margin = NOTE_PAGE_MARGIN * scale;
  const cropSide = NOTE_CROP_SIDE * scale;
  const cardX = margin + cropSide + NOTE_CROP_CARD_GAP * scale;
  const cardWidth = pdfPageWidth - margin - cardX;
  const frameInset = NOTE_CARD_FRAME_INSET * scale;
  const bodyPadX = NOTE_BODY_PAD_X * scale;
  const headerPadY = NOTE_CARD_HEADER_PAD_Y * scale;
  const groupFontSize = NOTE_GROUP_FONT_SIZE * scale;
  const bylineFontSize = NOTE_BYLINE_FONT_SIZE * scale;
  const headerLineGap = NOTE_HEADER_LINE_GAP * scale;

  return {
    scale,
    margin,
    titleTop,
    contentTop: titleTop + NOTE_HEADER_HEIGHT * scale,
    contentBottom: pdfPageHeight - margin,
    entryGap: NOTE_ENTRY_GAP * scale,
    cropX: margin,
    cropSide,
    cardX,
    cardWidth,
    cardRadius: NOTE_CARD_RADIUS * scale,
    headerHeight:
      headerPadY * 2 + groupFontSize + headerLineGap + bylineFontSize,
    headerPadX: NOTE_CARD_HEADER_PAD_X * scale,
    headerPadY,
    headerLineGap,
    groupFontSize,
    bylineFontSize,
    frameInset,
    bodyRadius: NOTE_BODY_RADIUS * scale,
    bodyPadX,
    bodyPadY: NOTE_BODY_PAD_Y * scale,
    bodyFontSize: NOTE_BODY_FONT_SIZE * scale,
    lineHeight: NOTE_BODY_LINE_HEIGHT * scale,
    textWidth: Math.min(
      NOTE_BODY_MAX_TEXT_WIDTH * scale,
      cardWidth - 2 * (frameInset + bodyPadX),
    ),
  };
};
